<template>
  <div class="zj-header-hegu" :style="{backgroundImage:'url('+headerBg+')'}"  >
      <div class="leftLine">
        <div class="homeBox">
          <img class="home" :src="homeIcon" alt="返回首页" @click="goHome"/>
          <div class="timeBox">
              <div>
                  <span class="time">{{curTime.hms}}</span>
              </div>
              <div>
                  <span  class="date">{{curTime.ymd}}</span>
                  <span  class="weekday">{{curTime.weekday}}</span>
              </div>
          </div>
      </div>
      <zj-nav-menu-hegu :height="height" :menuArr="smenu1"/>
    </div>
    <img class="zj-header-title" :src="headerTitle" alt="">
    <div class="rightLine">
       <zj-nav-menu-hegu :height="height" :menuArr="smenu2"/>
       <zj-action-panel-hegu :height="height"  />
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { validateAccessToken } from "@/api/system/permission/login";
// removeToken
import { getToken } from '@/utils/auth'
export default {
  name: "ZjHeaderHegu",
  props: {
    height: String,
  },
  data(){
    return{
      timer: null,
      curTime:{
        ymd:'',
        hms:'',
        weekday:''
      },
      smenu1:[],
    }
  },
  watch:{
    "menu.MenuInfos":{
      handler (newval) {
        let len = newval.length;
          if(len%2==0){
          let result =this.arrayChunk(newval,len/2);
            this.smenu1 = result[0];
            this.smenu2 = result[1];
        }else{
            let size = parseInt(len/2)+1
            let result =this.arrayChunk(newval,size);
            this.smenu1 = result[0];
            this.smenu2 = result[1];
        }
      },
      deep: true,
      immediate: true,
    }
  },
  computed: {
    style() {
      return {
        height: this.height,
      };
    },
    title() {
      return this.theme.header.title.text
    },
    headerBg(){
      return  '/theme/default/img/common/' + this.config.app.project + '/header-bg.png'
    }, 
    headerTitle(){
      return  '/theme/default/img/common/' + this.config.app.project + '/header-title.png'
    },
    homeIcon(){
      return  '/theme/default/img/common/' + this.config.app.project + '/header-icon-home.png'

    } 
  },
  mounted(){
    this.getDate()
    this.timer = setInterval(() => {
      this.getDate()
    }, 1000);
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    goHome(){
      if(this.theme.header.title.webUrl){
        validateAccessToken(getToken())
        .then((res) => {
          if (res.code == 200) {
           if(res.data){
             window.open(this.theme.header.title.webUrl,"_self")
           }else {
            this.$message({type: "error", message: "accessToken已失效"});
            this.logout()
          }
          } 
        })
        return
      }
      this.$router.firstSetup(this,true);
    },
    arrayChunk(array, size){
      let data = []
      for (let i = 0; i < array.length; i += size) {
          data.push(array.slice(i, i + size))
      }
      return data
    },
    getDate(){
      let obj =  {
        ymd:moment().format("HH:mm:ss"),
        hms:moment().format("YYYY-MM-DD"),
        weekday:this.getWeek()
      }
      this.curTime = obj
    },
    getWeek () { // 参数时间戳
      let week = moment().day()
      switch (week) {
        case 1:
          return '星期一'
        case 2:
          return '星期二'
        case 3:
          return '星期三'
        case 4:
          return '星期四'
        case 5:
          return '星期五'
        case 6:
          return '星期六'
        case 0:
          return '星期日'
      }
    },
  }
};
</script>
